import { render, staticRenderFns } from "./main-menu.vue?vue&type=template&id=6a8bd547&scoped=true&"
import script from "./main-menu.vue?vue&type=script&lang=ts&"
export * from "./main-menu.vue?vue&type=script&lang=ts&"
import style0 from "./main-menu.vue?vue&type=style&index=0&id=6a8bd547&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8bd547",
  null
  
)

export default component.exports